'use client'
import {
  addOrRemoveEventLocation,
  addOrRemoveEventLocationContinents,
  setEventLocation,
} from '@/app/globalRedux/filter/eventFilter'
import { setAddOrRemoveMonth } from '@/app/globalRedux/filter/eventFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import { months } from '@/app/utils/numberToMonth'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CompanyLocationFilter from '../CommonFilters/CompanyLocationFilter'

const EventLocationMonthFilter = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const eventFilter = useSelector((state: RootState) => state.eventFilter)
  const [EventLocation, setEventLocationText] = useState<string>('')
  return (
    <div>
      {/* Month */}
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <Accordion type="single" collapsible defaultValue="Month">
          <AccordionItem value="Month">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
              {t('Month')}
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col ">
                <div className="flex flex-col gap-[8px] mt-0 max-h-[200px] overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                  <RadioGroup
                    value={eventFilter?.month || ''}
                    onValueChange={(value) => {
                      dispatch(setAddOrRemoveMonth(value))
                    }}
                  >
                    {months.map((month: string) => (
                      <div
                        className="flex flex-row items-center gap-2 checked-color"
                        key={month}
                      >
                        <Label className="flex gap-2 text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]">
                          <RadioGroupItem
                            value={month}
                            className="!text-[#df7d2f]"
                            checked={eventFilter?.month === month}
                          />
                          {t(month)}
                        </Label>
                      </div>
                    ))}
                  </RadioGroup>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
      {/* Company Location */}
      <CompanyLocationFilter
        searchTitle={'Event Location'}
        locationText={EventLocation}
        setLocationText={setEventLocationText}
        continentSelectedList={eventFilter?.eventLocationContinents}
        countrySelectedList={eventFilter?.eventLocation}
        setWholeLocation={setEventLocation}
        addOrRemoveSelectedCountryList={addOrRemoveEventLocation}
        addOrRemoveSelectedContinentList={addOrRemoveEventLocationContinents}
      />
    </div>
  )
}

export default EventLocationMonthFilter
